import { Primary, PrimaryDark } from './Palettes/index.js';
export { CHART_COLOR_KEYS } from './chartColors.js';
export const palette = {
    primary: Primary,
    primaryDark: PrimaryDark,
};
